/* eslint-disable no-unused-vars */
import * as React from 'react';
import { Slider, Sketch, Material, Colorful, Compact, Circle, Wheel, Block, Github, Chrome } from '@uiw/react-color';
import { Alpha, Hue, ShadeSlider, Saturation, Interactive, hsvaToHslaString } from '@uiw/react-color';
import { EditableInput, EditableInputRGBA, EditableInputHSLA } from '@uiw/react-color';

import PropTypes from 'prop-types';
import {Button, TextField, Typography} from '@mui/material';
import { CloseOutlined, EditOutlined } from '@mui/icons-material';

/* eslint-disable no-useless-escape */
export default class FColorPicker extends React.Component{

    constructor(props){
        super(props);
        this.state={
            error:'',
            helperText:'',
            errorCustom:false,
            color:'',
            showPicker:false,
            value:'#ccc'
        }

    this.wrapperRef = React.createRef();
    this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount(){ 
        if(this.props.error === true){
            this.setState({error: this.props.error, helperText: this.props.helperText})
        }
        document.addEventListener("mousedown", this.handleClickOutside);
      }
    
      componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
      }
    
      /**
       * Alert if clicked on outside of element
       */
      handleClickOutside(event) {
        if (this.wrapperRef && this.state.showPicker) {
            if(!this.wrapperRef.current.contains(event.target)){
                this.setState({showPicker: false})  
            }
        }
      }

  static getDerivedStateFromProps(nextProps, prevState) {
    if(nextProps.value !== prevState.value){
        console.log("VALUE", nextProps.value, prevState.value)
        return {value: nextProps.value}
    }
    if (nextProps.error !== prevState.error && !prevState.errorCustom ) {
      return { error: nextProps.error, helperText: nextProps.helperText };
    }
    return null;
  }

render(){
    return  <>
     {this.props.label && <Typography variant="body2" style={{fontWeight:'bold', fontSize:'500'}} >
            {this.props.label}
          </Typography> }
          {/* <TextField fullWidth onFocus={()=>{
            this.setState({showPicker: true})
          }} 
        //   onBlur={()=>{
        //     this.setState({showPicker:false})
        //   }} 
          value={this.state.value} /> */}
    <div style={{display:'flex', flexDireciton:'row', gap:'10px'}}>
    <div onClick={()=>{
        this.setState({showPicker:true})
    }} style={{width:'100px', height:'50px', background:this.state.value !== '' && this.state.value !== null && this.state.value !== undefined ? this.state.value : '#ccc'}}>&nbsp;</div>
    <EditOutlined  onClick={()=>{
        this.setState({showPicker:true})
    }}/>
    </div>
    
    {this.state.showPicker && <div ref={this.wrapperRef} style={{position:'absolute', zIndex:99999, border:'1px solid #f0f0f0', background:'#fff', padding:'1rem'}}>
        <div style={{display:'flex', alignItems:'flex-end', justifyContent:'flex-end' }}>
            <CloseOutlined onClick={()=>{
                this.setState({showPicker: false})  
            }}/>
        </div>
        <Sketch
        style={{ boxShadow:'none', border:'0' }}
        color={this.state.value !== null ? this.state.value : '#ccc'}
        onChange={(color) => {
            this.setState({color:color.hex}, ()=>{
                this.props.onChange(this.state.color)
            })
        }}
        />  
    
    </div>}
            {this.props.error && this.props.helperText!==''&& <p className='error'>{this.props.helperText}</p>}
    </>
}

}


FColorPicker.propTypes = {
    label: PropTypes.string,
    name: PropTypes.string,
    id: PropTypes.string,
    error: PropTypes.bool,
    disabled:PropTypes.bool,
    helperText: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.string,
    required: PropTypes.bool, 
    onChange: PropTypes.func, 
    defaultValue: PropTypes.string, 
  };
